module.exports = __webpack_public_path__ + "img/model-1.968cd040.png";